import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import { Col, Row } from "antd";
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
export default class allElementsBanner extends React.Component {
    componentDidMount() {
       
    }

    render() {
        return (
          <div className="allElements-banner">
            <div className="allElements-banner-content">
              {/* <h1><Texty>更快捕捉，精准建模</Texty></h1> */}
              <div className="video-container video">
                <video
                  x5-playsinline="true"
                  playsinline="true"
                  webkit-playsinline="true"
                  src="https://qiniu.metridynamic.com/video/allElement/%E5%85%A8%E8%A6%81%E7%B4%A0%E9%87%87%E9%9B%86%E6%96%B9%E6%A1%88-%E4%B8%AD%E6%96%87.mp4"
                  autoPlay
                  loop
                  muted
                ></video>
              </div>
            </div>
          </div>
        );

    }
}
